export const columnasSuperInstitutosClassics = [
  {
    label: "ID",
    field: "idSuperInstituto",
    sort: "asc",
    width: 150,
  },
  {
    label: "Nombre",
    field: "nombre",
    sort: "asc",
    width: 270,
  },
  {
    label: "Lecturas Diarias",
    field: "lecturasDiarias",
    sort: "asc",
    width: 270,
  },
  {
    label: "Numero Institutos",
    field: "numInstitutos",
    sort: "asc",
    width: 270,
  },
]; 